import { useEffect } from 'react';

const BASE = 'https://remote-assistant.ai';

export default function Canonical({ path }) {
  useEffect(() => {
    const href = `${BASE}${path}`;
    let tag = document.querySelector('link[rel="canonical"]');
    if (!tag) {
      tag = document.createElement('link');
      tag.rel = 'canonical';
      document.head.appendChild(tag);
    }
    tag.href = href;
    return () => { tag.href = ''; };
  }, [path]);
  return null;
}
